(function() {
    'use strict';

    angular
        .module('edistradaIdealeasingPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('newClientEmail', {
            parent: 'application',
            url: '/client/newEmail',
            params: { clientLogin: null },
            data: {
                authorities: ['CLIENT_RESOURCE'],
                pageTitle: 'Aktualizuj email klienta - VB Leasing'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/newClientEmail/newClientEmail.html',
                    controller: 'newClientEmailController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
